import { gql } from '@apollo/client';

const DATA_WAREHOUSE_EXPORT = gql`
    query DataWarehouseExport($dataWarehouseExportId: UUID!) {
        dataWarehouseExport(dataWarehouseExportId: $dataWarehouseExportId) {
            node {
                id
                exportTypeId
                s3Key
                format
                status
                metadata
                startedAt
                completedAt
                createdAt
                updatedAt
                url
            }
        }
    }
`;

export default DATA_WAREHOUSE_EXPORT;
